var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3798 2.64331L15.4751 2.64816C15.9441 2.69587 16.3101 3.09196 16.3101 3.57354V17.217C16.3101 17.7307 15.8936 18.1472 15.3798 18.1472H3.5969C3.08315 18.1472 2.66667 17.7307 2.66667 17.217V3.57354L2.67152 3.47826C2.71924 3.00927 3.11532 2.64331 3.5969 2.64331H15.3798ZM4.52714 16.2867H14.4496V4.50378H4.52714V16.2867Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4031 21.248L28.4984 21.2529C28.9674 21.3006 29.3333 21.6967 29.3333 22.1783V27.7597C29.3333 28.2734 28.9169 28.6899 28.4031 28.6899H3.5969C3.08315 28.6899 2.66667 28.2734 2.66667 27.7597V22.1783L2.67152 22.083C2.71924 21.614 3.11532 21.248 3.5969 21.248H28.4031ZM4.52714 26.8294H27.4729V23.1085H4.52714V26.8294Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4031 2.64331L28.4984 2.64816C28.9674 2.69587 29.3333 3.09196 29.3333 3.57354V8.53478C29.3333 9.04854 28.9169 9.46502 28.4031 9.46502H20.3411C19.8273 9.46502 19.4109 9.04854 19.4109 8.53478V3.57354L19.4157 3.47826C19.4634 3.00927 19.8595 2.64331 20.3411 2.64331H28.4031ZM21.2713 7.60455H27.4729V4.50378H21.2713V7.60455Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4031 11.3254L28.4984 11.3303C28.9674 11.378 29.3333 11.7741 29.3333 12.2557V17.2169C29.3333 17.7307 28.9169 18.1471 28.4031 18.1471H20.3411C19.8273 18.1471 19.4109 17.7307 19.4109 17.2169V12.2557L19.4157 12.1604C19.4634 11.6914 19.8595 11.3254 20.3411 11.3254H28.4031ZM21.2713 16.2867H27.4729V13.1859H21.2713V16.2867Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.44cc0c22003e6b4f52dbb00e5f5bc6c5.svg";
export { ForwardRef as ReactComponent };